import { render, staticRenderFns } from "./FirmCreateOrUpdateContact.vue?vue&type=template&id=08646a4e&"
import script from "./FirmCreateOrUpdateContact.vue?vue&type=script&lang=js&"
export * from "./FirmCreateOrUpdateContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports